import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';

import { SearchForm, SearchBtn } from './SearchBarStyle';
import searchIcon from '../../imgs/svgs/searchIcon.svg';

const SearchBar = () => {
  const [searchText, setSearchText] = useState('');
  const [movie, setMovie] = useState('');

  const sendQuery = (e) => {
    e.preventDefault();
    setMovie(searchText);
  };

  useEffect(() => {
    setMovie('');
  }, []);

  if (movie !== '') {
    return (
      <Redirect
        to={{
          pathname: `/search-results/${movie}`,
        }}
      />
    );
  }

  return (
    <SearchForm>
      <form onSubmit={sendQuery}>
        <div className='search-field'>
          <label htmlFor='search'>
            <img
              className='search-icon'
              src={searchIcon}
              alt='Search for movie'
            />
          </label>
          <input
            onChange={(e) => setSearchText(e.target.value)}
            id='search'
            type='text'
            value={searchText}
          />
        </div>
        <SearchBtn type='submit'>Search</SearchBtn>
      </form>
    </SearchForm>
  );
};

export default SearchBar;
